// extracted by mini-css-extract-plugin
export default {"addSlotButton":"styles_addSlotButton__MXJww"};